"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useQuestionnaireNavigation = require("../hooks/questionnaire/useQuestionnaireNavigation");
var _useLocalTheme = _interopRequireDefault(require("../hooks/useLocalTheme"));
var _services = require("../services");
var _questionnaireSelectors = require("../store/questionnaire/questionnaireSelectors");
var _uiSelectors = require("../store/ui/uiSelectors");
var _constants = require("../utils/constants");
var _useAppSelector = require("../hooks/useAppSelector");
var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StepperContainer = _styledComponents.default.div`
  width: 100%;
  & span {
    color: black;
  }
`;
const EntelStepper = () => {
  const {
    numberOfQuestions,
    currentJourneyQuestionIndex,
    nameOfJourney
  } = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)();
  const selection = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectCurrentSelections);
  const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
  const hideStepperJourneyName = (0, _useConfig.default)('uiSettings.hideStepperJourneyName');
  const numberOfQuestion = currentJourneyQuestionIndex === 1 && selection.length === 0 ? '' : `${currentJourneyQuestionIndex}${_services.Services.locale.localeString('ProgressBar.questionNumber')}${numberOfQuestions}`;
  const showMainStepper = (0, _useLocalTheme.default)('showMainStepper', false);
  if (!showMainStepper) return null;

  //if not in the questionnaire page dont render
  if (currentPage !== _constants.PAGES.QUESTIONNAIRE) return null;
  return /*#__PURE__*/_react.default.createElement(StepperContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ProgressBar, {
    value: currentJourneyQuestionIndex / numberOfQuestions * 100,
    appearance: "primary",
    topText: {
      left: !hideStepperJourneyName && nameOfJourney,
      right: numberOfQuestion
    },
    srLabel: "Progress bar",
    dataAttributes: {
      'data-test-id': 'progress-bar'
    }
  }));
};
var _default = EntelStepper;
exports.default = _default;